import { Box, Flex, Grid, Heading } from "@chakra-ui/react";
import React from "react";
import ProjectCard from "./ProjectCard";

let projectData = [
  {
    img: "violenthope.png",
    name: "Violent Hope clone",
    description:
      "Clone of e-commerce website Mytheresa. Authentican, homepage, product, cart,server deployed on Render. Built by group of 5",
    live: "https://violent-hope.netlify.app/",
    github: "https://github.com/hurmitg/violent-hope-9407",
    arr: [
      "reactlogo.png",
      "chakralogo.jpeg",
      "nodelogo.png",
      "expresslogo.png",
      "mongodblogo.png",
    ],
  },
  {
    img: "myHours.png",
    name: "MyHours clone",
    description:
      "Clone of Project-tracking wesite MyHours. Homepage, support,authentican,project tracking page included. Built by group of 5",
    live: "https://myhour.vercel.app/",
    github: "https://github.com/Surya9263/hideous-crack-5602",
    arr: ["reactlogo.png", "chakralogo.jpeg", "reduxlogo.png"],
  },
  {
    img: "DNA.png",
    name: "DNA News Clone",
    description:
      "Clone of DNA new website. News api used, different section of news added. Build by group of 5",
    live: "https://luxury-lollipop-1d0feb.netlify.app/lifestyle.html",
    github: "https://github.com/utkarshqw/DNA-News-clone",
    arr: ["htmllgo.png", "csslogo.png", "jslogo.png"],
  },
  {
    img: "farfetch.png",
    name: "Farfetch Clone",
    description:
      "Clone of e-commerce website Farfetch where female fashion product can be found. Hompage and newin section",
    live: "https://fw18-1237-farfetch-clone.vercel.app/",
    github: "https://github.com/utkarshqw/Farfetch-clone/tree/main/farfetch",
    arr: ["reactlogo.png", "htmllgo.png", "csslogo.png", "jslogo.png"],
  },
];

const Project = () => {
  return (
    <Box id="project" pos={"relative"} zIndex={2} border="1px solid white" p="60px 0px">
      <Box border="1px solid white" m="auto" display={"inline-block"}>
        <Heading color="black">Projects</Heading>
        <Box
          h="6px"
          w="100%"
          mt="10px"
          bg="rgb(34,83,200)"
          borderRadius={"5px"}
        ></Box>
      </Box>
      <br />
      <br />
      <br />
      <br />

      <Flex flexWrap={"wrap"} w="70%" m="auto" gap="60px" justifyContent={"center"}>
        {projectData.map((elem, index) => (
          // <Box  key={index} align="center">
          <ProjectCard key={index} {...elem} />
          // </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default Project;
